import WomenImg from "../assets/img/banner-woman2.webp";
import Logo from "../assets/img/profile.png";

function Hero() {
  return (
    <section
      id="home"
      className="lg:h-[85vh] flex items-center bg-primary lg:bg-cover lg:bg-center lg:big-no-repeat py-32 lg:py-0 overflow-hidden"
    >
      <div className="container mx-auto h-full">
        <div className="flex items-center h-full pt-8">
          {/* left side  */}
          <div className="flex-1 flex flex-col items-center lg:items-start">
            <p className="text-3xl  text-violet-400 mb-[5px]">Hey , I'm Ghanisht</p>
            <h1 className="text-4xl leading-[44px] md:text-5xl  lg:text-7xl lg:leading-[1.2]">
              I am a Full-Stack Web Developer.
            </h1>
            <a
              href="https://drive.google.com/uc?id=1D_caW2ifqTWnrfp_QuCsYHo9tdRnyLIA&export=download"
              target="_blank"
            >
              <button className="btn btn-md mt-[18px] bg-violet-700 hover:bg-violet-500 md:btn-lg transition-all">
                Download Resume
              </button>
            </a>
          </div>
          {/* right side  */}
          {/* Image  */}
          <div className="hidden md:flex flex-1 justify-end items-end h-full lg:flex flex-1 justify-end items-end h-full">
            <img width={400} src="https://i.postimg.cc/HjDWGLQq/photo-2023-03-01-01-30-04-removebg-preview.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
